// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HistoricPage — System State Dashboard */

.hst-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #0a0a0a;
  color: #ffffff;
  overflow: hidden;
}

/* ─── Header ─────────────────────────────────────────── */

.hst-header {
  background: #1a1a1a;
  border-bottom: 1px solid #374151;
  padding: 22px 24px;
  flex-shrink: 0;
}

.hst-header-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.hst-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
}

.hst-subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: #9ca3af;
}

.hst-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.hst-date-range {
  display: flex;
  align-items: center;
  gap: 8px;
}

.hst-date-input {
  padding: 8px 10px;
  background: #0a0a0a;
  border: 1px solid #374151;
  border-radius: 8px;
  color: #ffffff;
  font-size: 13px;
  outline: none;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.hst-date-input:focus {
  border-color: #A61B34;
  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);
}

.hst-date-input::-webkit-calendar-picker-indicator {
  filter: invert(0.6);
  cursor: pointer;
}

.hst-date-sep {
  color: #6b7280;
  font-size: 13px;
}

.hst-btn-primary {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 16px;
  background: #A61B34;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
}

.hst-btn-primary:hover:not(:disabled) { background: #8B1528; }
.hst-btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }

.hst-btn-secondary {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 14px;
  background: transparent;
  color: #d1d5db;
  border: 1px solid #374151;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
  white-space: nowrap;
}

.hst-btn-secondary:hover:not(:disabled) {
  background: #2d2d2d;
  border-color: #4b5563;
  color: #ffffff;
}

.hst-btn-secondary:disabled { opacity: 0.5; cursor: not-allowed; }

/* ─── Body ───────────────────────────────────────────── */

.hst-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 22px 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* ─── Filter Cards ───────────────────────────────────── */

.hst-filter-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
}

.hst-filter-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  background: #111111;
  border: 1.5px solid #2d2d2d;
  border-radius: 12px;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.18s, background 0.18s, transform 0.12s;
  color: #ffffff;
}

.hst-filter-card:hover {
  border-color: var(--card-color, #4b5563);
  background: #161616;
  transform: translateY(-1px);
}

.hst-filter-card--active {
  border-color: var(--card-color, #A61B34) !important;
  background: var(--card-bg, rgba(166,27,52,0.12)) !important;
  box-shadow: 0 0 0 1px var(--card-color, #A61B34) inset;
}

.hst-filter-card-icon {
  width: 38px;
  height: 38px;
  border-radius: 9px;
  background: var(--card-bg, rgba(59,130,246,0.12));
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--card-color, #3B82F6);
}

.hst-filter-card-body {
  flex: 1 1;
  min-width: 0;
}

.hst-filter-card-count {
  font-size: 24px;
  font-weight: 700;
  color: var(--card-color, #ffffff);
  line-height: 1;
}

.hst-filter-card-label {
  font-size: 12px;
  color: #9ca3af;
  margin-top: 3px;
}

.hst-filter-card-dot {
  position: absolute;
  top: 10px;
  right: 12px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--card-color, #A61B34);
}

/* ─── Info bar ───────────────────────────────────────── */

.hst-info-bar {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.hst-info-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: #111111;
  border: 1px solid #2d2d2d;
  border-radius: 20px;
  font-size: 12px;
  color: #9ca3af;
}

/* ─── Filters ────────────────────────────────────────── */

.hst-filters {
  display: flex;
  gap: 12px;
  align-items: center;
}

.hst-search-wrap {
  position: relative;
  flex: 1 1;
}

.hst-search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  pointer-events: none;
}

.hst-search-input {
  width: 100%;
  padding: 10px 12px 10px 36px;
  background: #111111;
  border: 1px solid #374151;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
}

.hst-search-input:focus {
  border-color: #A61B34;
  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);
}

.hst-search-input::placeholder { color: #6b7280; }


/* ─── Error / Loading ────────────────────────────────── */

.hst-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.25);
  border-radius: 8px;
  color: #EF4444;
  font-size: 13px;
}

.hst-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 52px;
  color: #9ca3af;
  font-size: 14px;
}

@keyframes hst-spin { to { transform: rotate(360deg); } }
.hst-spin { animation: hst-spin 0.9s linear infinite; }

/* ─── Table ──────────────────────────────────────────── */

.hst-table-wrap {
  background: #111111;
  border: 1px solid #2d2d2d;
  border-radius: 12px;
  overflow: hidden;
}

.hst-table {
  width: 100%;
  border-collapse: collapse;
}

.hst-table thead tr {
  background: #0f0f0f;
  border-bottom: 1px solid #374151;
}

.hst-table th {
  padding: 11px 16px;
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  white-space: nowrap;
}

.hst-table td {
  padding: 13px 16px;
  font-size: 13px;
  border-bottom: 1px solid #1a1a1a;
  vertical-align: middle;
}

.hst-table-row {
  cursor: pointer;
  transition: background 0.15s;
}

.hst-table-row:hover { background: #161616; }

.hst-table-row:hover .hst-site-name { color: #c0253f; }

.hst-table-row:last-child td { border-bottom: none; }

.hst-table-empty {
  text-align: center !important;
  color: #6b7280;
  padding: 44px !important;
  font-size: 14px;
}

.hst-site-name {
  font-weight: 600;
  color: #ffffff;
  font-size: 13px;
  transition: color 0.15s;
}

.hst-site-addr {
  color: #6b7280;
  font-size: 12px;
  margin-top: 2px;
}

/* ─── Status badge ───────────────────────────────────── */

.hst-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.hst-badge-online  { background: rgba(16,185,129,0.12); color: #10B981; border: 1px solid rgba(16,185,129,0.25); }
.hst-badge-offline { background: rgba(239,68,68,0.12);  color: #EF4444; border: 1px solid rgba(239,68,68,0.25); }
.hst-badge-partial { background: rgba(245,158,11,0.12); color: #F59E0B; border: 1px solid rgba(245,158,11,0.25); }
.hst-badge-unknown { background: rgba(107,114,128,0.12);color: #9ca3af; border: 1px solid rgba(107,114,128,0.25); }

/* ─── Device counter ─────────────────────────────────── */

.hst-device-counter {
  font-size: 13px;
  font-weight: 600;
}

.hst-device-total {
  color: #6b7280;
  font-weight: 400;
  font-size: 12px;
}

.hst-device-none { color: #4b5563; font-size: 13px; }

/* ─── Operativity bar ────────────────────────────────── */

.hst-op-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 110px;
}

.hst-op-track {
  flex: 1 1;
  height: 5px;
  background: #2d2d2d;
  border-radius: 3px;
  overflow: hidden;
}

.hst-op-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.4s ease;
}

.hst-op-pct {
  font-size: 12px;
  font-weight: 600;
  min-width: 34px;
  text-align: right;
}

/* ─── Pagination ─────────────────────────────────────── */

.hst-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
}

.hst-pg-info {
  font-size: 13px;
  color: #9ca3af;
}

.hst-pg-btns { display: flex; gap: 6px; }

.hst-pg-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: #111111;
  border: 1px solid #374151;
  border-radius: 6px;
  color: #d1d5db;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.hst-pg-btn:hover:not(:disabled) { background: #1f2937; border-color: #4b5563; }
.hst-pg-btn:disabled { opacity: 0.35; cursor: not-allowed; }

/* ─── Modal ──────────────────────────────────────────── */

.hst-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
  backdrop-filter: blur(3px);
}

.hst-modal {
  background: #1a1a1a;
  border: 1px solid #374151;
  border-radius: 16px;
  width: 100%;
  max-width: 1280px;
  height: min(800px, 94vh);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.65);
}

.hst-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 22px 24px 16px;
  border-bottom: 1px solid #2d2d2d;
}

.hst-modal-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 17px;
  font-weight: 700;
  color: #ffffff;
}

.hst-modal-sub {
  margin-top: 4px;
  font-size: 13px;
  color: #9ca3af;
}

.hst-modal-close {
  background: transparent;
  border: 1px solid #374151;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
  flex-shrink: 0;
}

.hst-modal-close:hover {
  background: #2d2d2d;
  color: #ffffff;
  border-color: #4b5563;
}

/* Modal device summary */
.hst-modal-summary {
  display: flex;
  flex-wrap: wrap;
  padding: 14px 20px;
  border-bottom: 1px solid #2d2d2d;
  gap: 0;
}

.hst-modal-dev {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  border-right: 1px solid #2d2d2d;
}

.hst-modal-dev:first-child { padding-left: 4px; }
.hst-modal-dev:last-child  { border-right: none; }

.hst-modal-dev-icon { color: #6b7280; display: flex; align-items: center; }
.hst-modal-dev-lbl  { font-size: 12px; color: #9ca3af; }
.hst-modal-dev-cnt  { font-size: 14px; font-weight: 700; }

/* Tab buttons */
.hst-modal-tabs {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 14px 20px 0;
  border-bottom: 1px solid #2d2d2d;
  flex-wrap: wrap;
}

.hst-modal-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: transparent;
  border: 1px solid #374151;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  color: #9ca3af;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  position: relative;
  bottom: -1px;
}

.hst-modal-tab:hover:not(.hst-modal-tab--empty) {
  background: #2d2d2d;
  color: #d1d5db;
  border-color: #4b5563;
}

.hst-modal-tab--active {
  background: #111827;
  border-color: #A61B34;
  color: #ffffff;
}

.hst-modal-tab--empty {
  opacity: 0.4;
  cursor: default;
}

.hst-modal-tab-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  background: #2d2d2d;
  border-radius: 9px;
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
}

.hst-modal-tab--active .hst-modal-tab-badge {
  background: rgba(166, 27, 52, 0.25);
  color: #f9a8b8;
}

.hst-modal-tab-period {
  margin-left: auto;
  font-size: 12px;
  color: #6b7280;
  padding-bottom: 10px;
}

/* Device ON/OFF badge (router, sirena, xtam) */
.hst-sema {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 4px 10px 4px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid transparent;
  letter-spacing: 0.05em;
}
.hst-sema__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}
.hst-sema--on    { color: #bbf7d0; background: rgba(34,197,94,0.14);  border-color: rgba(34,197,94,0.35); }
.hst-sema--on    .hst-sema__dot { background: #22c55e; }
.hst-sema--off   { color: #fecaca; background: rgba(220,38,38,0.14);  border-color: rgba(220,38,38,0.38); }
.hst-sema--off   .hst-sema__dot { background: #dc2626; }
.hst-sema--unknown { color: #d1d5db; background: rgba(107,114,128,0.18); border-color: rgba(107,114,128,0.35); }
.hst-sema--unknown .hst-sema__dot { background: #6b7280; }

/* Chart section */
.hst-modal-chart {
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  padding: 16px 24px 24px;
}

/* Animación de entrada al cambiar de tab */
@keyframes hst-tab-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hst-tab-panel {
  animation: hst-tab-in 0.28s cubic-bezier(0.22, 1, 0.36, 1);
}

.hst-chart-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 220px;
  color: #6b7280;
  font-size: 14px;
}

.hst-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #2d2d2d;
}

.hst-legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #9ca3af;
}

.hst-legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.hst-chart-meta {
  margin-top: 8px;
  font-size: 11px;
  color: #4b5563;
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/pages/HistoricPage.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,2DAA2D;;AAE3D;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,wCAAwC,mBAAmB,EAAE;AAC7D,4BAA4B,YAAY,EAAE,mBAAmB,EAAE;;AAE/D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0DAA0D;EAC1D,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,8BAA8B,YAAY,EAAE,mBAAmB,EAAE;;AAEjE,2DAA2D;;AAE3D;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iEAAiE;EACjE,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mDAAmD;EACnD,2DAA2D;EAC3D,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,iCAAiC,cAAc,EAAE;;;AAGjD,2DAA2D;;AAE3D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB,KAAK,yBAAyB,EAAE,EAAE;AACxD,YAAY,wCAAwC,EAAE;;AAEtD,2DAA2D;;AAE3D;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,uBAAuB,mBAAmB,EAAE;;AAE5C,sCAAsC,cAAc,EAAE;;AAEtD,+BAA+B,mBAAmB,EAAE;;AAEpD;EACE,6BAA6B;EAC7B,cAAc;EACd,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,2DAA2D;;AAE3D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qBAAqB,iCAAiC,EAAE,cAAc,EAAE,uCAAuC,EAAE;AACjH,qBAAqB,gCAAgC,GAAG,cAAc,EAAE,sCAAsC,EAAE;AAChH,qBAAqB,iCAAiC,EAAE,cAAc,EAAE,uCAAuC,EAAE;AACjH,qBAAqB,kCAAkC,CAAC,cAAc,EAAE,wCAAwC,EAAE;;AAElH,2DAA2D;;AAE3D;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mBAAmB,cAAc,EAAE,eAAe,EAAE;;AAEpD,2DAA2D;;AAE3D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe,aAAa,EAAE,QAAQ,EAAE;;AAExC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,8CAA8C;AAChD;;AAEA,mCAAmC,mBAAmB,EAAE,qBAAqB,EAAE;AAC/E,uBAAuB,aAAa,EAAE,mBAAmB,EAAE;;AAE3D,2DAA2D;;AAE3D;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,0DAA0D;EAC1D,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,6BAA6B,iBAAiB,EAAE;AAChD,6BAA6B,kBAAkB,EAAE;;AAEjD,sBAAsB,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAC1E,sBAAsB,eAAe,EAAE,cAAc,EAAE;AACvD,sBAAsB,eAAe,EAAE,gBAAgB,EAAE;;AAEzD,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6DAA6D;EAC7D,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA,+CAA+C;AAC/C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA,mBAAmB,cAAc,EAAE,gCAAgC,GAAG,kCAAkC,EAAE;AAC1G,kCAAkC,mBAAmB,EAAE;AACvD,mBAAmB,cAAc,EAAE,gCAAgC,GAAG,kCAAkC,EAAE;AAC1G,kCAAkC,mBAAmB,EAAE;AACvD,qBAAqB,cAAc,EAAE,kCAAkC,EAAE,oCAAoC,EAAE;AAC/G,oCAAoC,mBAAmB,EAAE;;AAEzD,kBAAkB;AAClB;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,2CAA2C;AAC3C;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["/* HistoricPage — System State Dashboard */\n\n.hst-page {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: #0a0a0a;\n  color: #ffffff;\n  overflow: hidden;\n}\n\n/* ─── Header ─────────────────────────────────────────── */\n\n.hst-header {\n  background: #1a1a1a;\n  border-bottom: 1px solid #374151;\n  padding: 22px 24px;\n  flex-shrink: 0;\n}\n\n.hst-header-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.hst-title {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.hst-subtitle {\n  margin: 4px 0 0;\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.hst-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.hst-date-range {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.hst-date-input {\n  padding: 8px 10px;\n  background: #0a0a0a;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 13px;\n  outline: none;\n  cursor: pointer;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.hst-date-input:focus {\n  border-color: #A61B34;\n  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);\n}\n\n.hst-date-input::-webkit-calendar-picker-indicator {\n  filter: invert(0.6);\n  cursor: pointer;\n}\n\n.hst-date-sep {\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.hst-btn-primary {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 9px 16px;\n  background: #A61B34;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n  white-space: nowrap;\n}\n\n.hst-btn-primary:hover:not(:disabled) { background: #8B1528; }\n.hst-btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.hst-btn-secondary {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 9px 14px;\n  background: transparent;\n  color: #d1d5db;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s, color 0.2s;\n  white-space: nowrap;\n}\n\n.hst-btn-secondary:hover:not(:disabled) {\n  background: #2d2d2d;\n  border-color: #4b5563;\n  color: #ffffff;\n}\n\n.hst-btn-secondary:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* ─── Body ───────────────────────────────────────────── */\n\n.hst-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 22px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n/* ─── Filter Cards ───────────────────────────────────── */\n\n.hst-filter-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 12px;\n}\n\n.hst-filter-card {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 16px 18px;\n  background: #111111;\n  border: 1.5px solid #2d2d2d;\n  border-radius: 12px;\n  cursor: pointer;\n  text-align: left;\n  transition: border-color 0.18s, background 0.18s, transform 0.12s;\n  color: #ffffff;\n}\n\n.hst-filter-card:hover {\n  border-color: var(--card-color, #4b5563);\n  background: #161616;\n  transform: translateY(-1px);\n}\n\n.hst-filter-card--active {\n  border-color: var(--card-color, #A61B34) !important;\n  background: var(--card-bg, rgba(166,27,52,0.12)) !important;\n  box-shadow: 0 0 0 1px var(--card-color, #A61B34) inset;\n}\n\n.hst-filter-card-icon {\n  width: 38px;\n  height: 38px;\n  border-radius: 9px;\n  background: var(--card-bg, rgba(59,130,246,0.12));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: var(--card-color, #3B82F6);\n}\n\n.hst-filter-card-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.hst-filter-card-count {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--card-color, #ffffff);\n  line-height: 1;\n}\n\n.hst-filter-card-label {\n  font-size: 12px;\n  color: #9ca3af;\n  margin-top: 3px;\n}\n\n.hst-filter-card-dot {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--card-color, #A61B34);\n}\n\n/* ─── Info bar ───────────────────────────────────────── */\n\n.hst-info-bar {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.hst-info-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  background: #111111;\n  border: 1px solid #2d2d2d;\n  border-radius: 20px;\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n/* ─── Filters ────────────────────────────────────────── */\n\n.hst-filters {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.hst-search-wrap {\n  position: relative;\n  flex: 1;\n}\n\n.hst-search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  pointer-events: none;\n}\n\n.hst-search-input {\n  width: 100%;\n  padding: 10px 12px 10px 36px;\n  background: #111111;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  box-sizing: border-box;\n}\n\n.hst-search-input:focus {\n  border-color: #A61B34;\n  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);\n}\n\n.hst-search-input::placeholder { color: #6b7280; }\n\n\n/* ─── Error / Loading ────────────────────────────────── */\n\n.hst-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: rgba(239, 68, 68, 0.08);\n  border: 1px solid rgba(239, 68, 68, 0.25);\n  border-radius: 8px;\n  color: #EF4444;\n  font-size: 13px;\n}\n\n.hst-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 52px;\n  color: #9ca3af;\n  font-size: 14px;\n}\n\n@keyframes hst-spin { to { transform: rotate(360deg); } }\n.hst-spin { animation: hst-spin 0.9s linear infinite; }\n\n/* ─── Table ──────────────────────────────────────────── */\n\n.hst-table-wrap {\n  background: #111111;\n  border: 1px solid #2d2d2d;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.hst-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.hst-table thead tr {\n  background: #0f0f0f;\n  border-bottom: 1px solid #374151;\n}\n\n.hst-table th {\n  padding: 11px 16px;\n  text-align: left;\n  font-size: 11px;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  white-space: nowrap;\n}\n\n.hst-table td {\n  padding: 13px 16px;\n  font-size: 13px;\n  border-bottom: 1px solid #1a1a1a;\n  vertical-align: middle;\n}\n\n.hst-table-row {\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.hst-table-row:hover { background: #161616; }\n\n.hst-table-row:hover .hst-site-name { color: #c0253f; }\n\n.hst-table-row:last-child td { border-bottom: none; }\n\n.hst-table-empty {\n  text-align: center !important;\n  color: #6b7280;\n  padding: 44px !important;\n  font-size: 14px;\n}\n\n.hst-site-name {\n  font-weight: 600;\n  color: #ffffff;\n  font-size: 13px;\n  transition: color 0.15s;\n}\n\n.hst-site-addr {\n  color: #6b7280;\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n/* ─── Status badge ───────────────────────────────────── */\n\n.hst-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.hst-badge-online  { background: rgba(16,185,129,0.12); color: #10B981; border: 1px solid rgba(16,185,129,0.25); }\n.hst-badge-offline { background: rgba(239,68,68,0.12);  color: #EF4444; border: 1px solid rgba(239,68,68,0.25); }\n.hst-badge-partial { background: rgba(245,158,11,0.12); color: #F59E0B; border: 1px solid rgba(245,158,11,0.25); }\n.hst-badge-unknown { background: rgba(107,114,128,0.12);color: #9ca3af; border: 1px solid rgba(107,114,128,0.25); }\n\n/* ─── Device counter ─────────────────────────────────── */\n\n.hst-device-counter {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.hst-device-total {\n  color: #6b7280;\n  font-weight: 400;\n  font-size: 12px;\n}\n\n.hst-device-none { color: #4b5563; font-size: 13px; }\n\n/* ─── Operativity bar ────────────────────────────────── */\n\n.hst-op-cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 110px;\n}\n\n.hst-op-track {\n  flex: 1;\n  height: 5px;\n  background: #2d2d2d;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.hst-op-fill {\n  height: 100%;\n  border-radius: 3px;\n  transition: width 0.4s ease;\n}\n\n.hst-op-pct {\n  font-size: 12px;\n  font-weight: 600;\n  min-width: 34px;\n  text-align: right;\n}\n\n/* ─── Pagination ─────────────────────────────────────── */\n\n.hst-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 0;\n}\n\n.hst-pg-info {\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.hst-pg-btns { display: flex; gap: 6px; }\n\n.hst-pg-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: #111111;\n  border: 1px solid #374151;\n  border-radius: 6px;\n  color: #d1d5db;\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.hst-pg-btn:hover:not(:disabled) { background: #1f2937; border-color: #4b5563; }\n.hst-pg-btn:disabled { opacity: 0.35; cursor: not-allowed; }\n\n/* ─── Modal ──────────────────────────────────────────── */\n\n.hst-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.72);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 16px;\n  backdrop-filter: blur(3px);\n}\n\n.hst-modal {\n  background: #1a1a1a;\n  border: 1px solid #374151;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 1280px;\n  height: min(800px, 94vh);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.65);\n}\n\n.hst-modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 22px 24px 16px;\n  border-bottom: 1px solid #2d2d2d;\n}\n\n.hst-modal-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 17px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.hst-modal-sub {\n  margin-top: 4px;\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.hst-modal-close {\n  background: transparent;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 6px;\n  display: flex;\n  align-items: center;\n  transition: background 0.2s, color 0.2s, border-color 0.2s;\n  flex-shrink: 0;\n}\n\n.hst-modal-close:hover {\n  background: #2d2d2d;\n  color: #ffffff;\n  border-color: #4b5563;\n}\n\n/* Modal device summary */\n.hst-modal-summary {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 14px 20px;\n  border-bottom: 1px solid #2d2d2d;\n  gap: 0;\n}\n\n.hst-modal-dev {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 16px;\n  border-right: 1px solid #2d2d2d;\n}\n\n.hst-modal-dev:first-child { padding-left: 4px; }\n.hst-modal-dev:last-child  { border-right: none; }\n\n.hst-modal-dev-icon { color: #6b7280; display: flex; align-items: center; }\n.hst-modal-dev-lbl  { font-size: 12px; color: #9ca3af; }\n.hst-modal-dev-cnt  { font-size: 14px; font-weight: 700; }\n\n/* Tab buttons */\n.hst-modal-tabs {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 14px 20px 0;\n  border-bottom: 1px solid #2d2d2d;\n  flex-wrap: wrap;\n}\n\n.hst-modal-tab {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: transparent;\n  border: 1px solid #374151;\n  border-bottom: none;\n  border-radius: 8px 8px 0 0;\n  color: #9ca3af;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n  position: relative;\n  bottom: -1px;\n}\n\n.hst-modal-tab:hover:not(.hst-modal-tab--empty) {\n  background: #2d2d2d;\n  color: #d1d5db;\n  border-color: #4b5563;\n}\n\n.hst-modal-tab--active {\n  background: #111827;\n  border-color: #A61B34;\n  color: #ffffff;\n}\n\n.hst-modal-tab--empty {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.hst-modal-tab-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 4px;\n  background: #2d2d2d;\n  border-radius: 9px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #9ca3af;\n}\n\n.hst-modal-tab--active .hst-modal-tab-badge {\n  background: rgba(166, 27, 52, 0.25);\n  color: #f9a8b8;\n}\n\n.hst-modal-tab-period {\n  margin-left: auto;\n  font-size: 12px;\n  color: #6b7280;\n  padding-bottom: 10px;\n}\n\n/* Device ON/OFF badge (router, sirena, xtam) */\n.hst-sema {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 4px 10px 4px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  border: 1px solid transparent;\n  letter-spacing: 0.05em;\n}\n.hst-sema__dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.hst-sema--on    { color: #bbf7d0; background: rgba(34,197,94,0.14);  border-color: rgba(34,197,94,0.35); }\n.hst-sema--on    .hst-sema__dot { background: #22c55e; }\n.hst-sema--off   { color: #fecaca; background: rgba(220,38,38,0.14);  border-color: rgba(220,38,38,0.38); }\n.hst-sema--off   .hst-sema__dot { background: #dc2626; }\n.hst-sema--unknown { color: #d1d5db; background: rgba(107,114,128,0.18); border-color: rgba(107,114,128,0.35); }\n.hst-sema--unknown .hst-sema__dot { background: #6b7280; }\n\n/* Chart section */\n.hst-modal-chart {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  padding: 16px 24px 24px;\n}\n\n/* Animación de entrada al cambiar de tab */\n@keyframes hst-tab-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.hst-tab-panel {\n  animation: hst-tab-in 0.28s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.hst-chart-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  min-height: 220px;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.hst-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid #2d2d2d;\n}\n\n.hst-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.hst-legend-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.hst-chart-meta {\n  margin-top: 8px;\n  font-size: 11px;\n  color: #4b5563;\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
